import React, { useState } from 'react';

import { useParams } from 'react-router-dom';

import CRMApi from '../../../../Api/CRM/CRMApi';
import GetLootboxRewardResponse from '../../../../Api/CRM/Responses/Lootbox/LootboxItemResponse';
import { formatDateStringWithTimezone } from '../../../../utils/formatters';
import ProtectedLink from '../../../elements/ProtectedLink';
import { PERMISSION } from '../../../helpers/Permissions';
import useOnce from '../../../hooks/useOnce';

import Card from 'crm/elements/common/Card';
import Row, { TableDetailsBody } from 'crm/elements/common/TableDetailsRow';

export default function LootboxItemDetailsPage() {
    const { id } = useParams<{ id: string }>();
    const [reward, setReward] = useState<GetLootboxRewardResponse>({} as GetLootboxRewardResponse);
    useOnce(() => CRMApi.lootboxItems.getById(parseInt(id)).then(setReward));

    return (
        <Card title="Lootbox Reward details">
            <TableDetailsBody>
                <Row label="ID">{reward.id}</Row>
                <Row label="Name">{reward.name}</Row>
                <Row label="Description">{reward.description}</Row>
                <Row label="Lootbox id">
                    <ProtectedLink
                        url={`/lootboxes/${reward.lootbox_id}`}
                        value={reward.lootbox_id}
                        permissions={[PERMISSION.VIEW_USER]}
                    />
                </Row>
                <Row label="Value">{reward.value}</Row>
                <Row label="Value Currency Code">{reward.value_currency_code}</Row>
                <Row label="Rarity">{reward.rarity}</Row>
                <Row label="Type">{reward.type}</Row>
                <Row label="Count">{reward.count}</Row>
                <Row label="Created at">{formatDateStringWithTimezone(reward.created_at)}</Row>
            </TableDetailsBody>
        </Card>
    );
}
